import api from "./api";

/**
 * GET user bookings
 * @param {String} status - Filter by status
 * @param {Number} page - Page number
 * @param {Number} limit - Items per page
 */
export const getUserBookings = (status = null, page = 1, limit = 10) => {
  const params = {
    page,
    limit,
  };

  if (status) {
    params.status = status;
  }

  return api.get("/bookings", { params });
};

/**
 * Add items to cart before booking
 * @param {Object} data - { serviceTypeId, requested_date, requested_time, description }
 */
export const addToCart = (data) => {
  return api.post("/cart/add", data);
};

/**
 * Finalize the booking
 * @param {Object} data - { description }
 */
export const createBooking = (data) => {
  return api.post("/booking", data);
};
/**
 * Get specific booking details
 * @param {String} bookingId
 */
export const getBookingById = (bookingId) => {
  return api.get(`/booking/${bookingId}`);
};
